<div *ngIf='componentReady' class='EditCampaign p-0 p-sm-3'>
  <div class='Breadcrumbs mb-'>
    <div class='Breadcrumbs-items'>
      <a [routerLink]="['/campaigns']"
      >
        <mat-icon class='Breadcrumbs-icon back'
        >keyboard_backspace
        </mat-icon
        >
      </a
      >
      <a [routerLink]="['/campaigns']" class='Breadcrumbs-item first'
      >Active Campaigns</a
      >
      <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
      <ng-container *ngIf='state !== "edit"; else editCampaign'>
        <span class='Breadcrumbs-item first'>New Campaign</span>
        <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
        <span class='Breadcrumbs-item'>Campaign Wizard</span>
      </ng-container>
      <ng-template #editCampaign>
        <span class='Breadcrumbs-item'>Edit {{ campaignInfo.campaign_name }}</span>
      </ng-template>
    </div>
  </div>
  <div class='EditCampaign-body mt-3 mt-sm-5 p-0 p-sm-5'>
    <div class='EditCampaign-body-info mb-3 mb-sm-5 ps-3 ps-sm-0 pt-3 pt-sm-0'>
      <span class=''>Create or update Your Campaign</span>
    </div>
    <div *ngIf='campaignNameMissingError' class='alert alert-danger'>
      <p class='mb-0'>Please enter campaign name</p>
    </div>
    <div *ngIf='campaignNameTaken' class='alert alert-danger'>
      <p class='mb-0'>
        Campaign with this name, already exists! Please, choose a different
        name!
      </p>
    </div>
    <div *ngIf='missingFrequency' class='alert alert-danger'>
      <p class='mb-0'>Please, choose a valid frequency for you campaign!</p>
    </div>
    <div class='EditCampaign-body-form p-3 p-sm-0'>
      <form [formGroup]='formGroup' class='text-start'>
        <div class='row'>
          <div class='col col-12 col-sm-4'>
            <mat-label>Select Campaign Type</mat-label>
          </div>
          <div class='col col-12 col-sm-4'>
            <mat-radio-group
              (change)='onCampaignTypeSelection($event)'
              aria-label='Select an option'
              formControlName='campaign_type'>
              <mat-radio-button class='bold-radio' value='Standard'
              >Standard
              </mat-radio-button
              >
              <mat-radio-button class='ms-3 bold-radio' value='Frequency'
              >Frequency
              </mat-radio-button
              >
            </mat-radio-group>
          </div>
          <div *ngIf='formGroup.get("campaign_type").value === "Frequency"' class='col col-12 col-sm-4 mt-3 mt-sm-0'>
            <app-button [Click]='updateFreq.onClick' [color]='updateFreq.color' [size]='updateFreq.size'
                        [style]='updateFreq.style'
                        [text]='updateFreq.text'></app-button>
          </div>
        </div>

        <div class='row'>
          <div class='col col-12 col-sm-4'>
            <mat-label>Campaign Name</mat-label>
          </div>
          <div class='col col-12 col-sm-8'>
            <app-text-field
              formControlName='campaign_name'
              placeholder='Campaign name'></app-text-field>
          </div>
        </div>
        <div class='row'>
          <div class='col col-12 col-sm-8 offset-sm-4'>
            <app-button
              [Click]='createButton.onClick'
              [color]='createButton.color'
              [size]='createButton.size'
              [text]='getCreateButtonText()'
              [observeApi]="true"
              class='ms-0 ms-sm-3'></app-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
